<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 19 18">
    <g clip-path="url(#clip0_6892_9062)">
      <path
        d="M12.6417 4.61647L13.394 3.85412L18.7778 9L13.394 14.1459L12.6417 13.3835L16.6716 9.52941H5.10858V8.47059H16.6823L12.6525 4.61647H12.6417ZM9.34261 16.9412H2.38977C2.08888 16.9412 1.85246 16.7082 1.85246 16.4118V1.58824C1.85246 1.29176 2.08888 1.05882 2.38977 1.05882H9.35335V0H2.38977C1.49783 0 0.777832 0.709412 0.777832 1.58824V16.4118C0.777832 17.2906 1.49783 18 2.38977 18H9.34261V16.9412Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_9062">
        <rect width="18" height="18" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
